import angular from 'angular';
import constants from 'app/constants';
import {
  bcpSharedModelService,
  vmSharedModelService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog
} from 'app/components/global';
import selectVendorResourcesDialog from './dialog.selectVendorResourcesDialog';
import vendorResource from './vendorResource';
import controller from './vendor-resources.controller';
import directive from './vendor-resources.directive';


export default angular.module('app.components.advisory.bcp.vendorResources', [
  alerts,
  bcpSharedModelService,
  vmSharedModelService,
  confirmDialog,
  constants,
  selectVendorResourcesDialog,
  loaderService,
  ssDialogService,
  userService,
  vendorResource,
])
  .directive('bcpVendorResources', directive)
  .controller('VendorResourcesController', controller)
  .name;

console.log('app.components.advisory.bcp.vendorResources created');
